/** @module store/actions */
import api from "@/api.js"

/**
 * <pre>
 *  MUTATION
 *         |---> [FETCH_PVI]{@link module:store/mutations.FETCH_PVI}
 *         |
 *         |---> [API_FAILURE]{@link module:store/mutations.API_FAILURE}
 * </pre>
 */
export const GETPVI = context => {
  context.commit("LOADING")
  return api
    .get("/prodvaringr")
    .then(response => context.commit("FETCH_PVI", response))
    .catch(error => context.commit("API_FAILURE", error))
}

/**
 * <pre>
 *  MUTATION
 *         |---> [FETCH_TERMINALS]{@link module:store/mutations.FETCH_TERMINALS}
 *         |
 *         |---> [API_FAILURE]{@link module:store/mutations.API_FAILURE}
 * </pre>
 */
export const GETTERMINALS = context => {
  context.commit("LOADING")
  return api
    .get("/tavCloud/api/v1/get/terminals/")
    .then(response => context.commit("FETCH_TERMINALS", response))
    .catch(error => context.commit("FETCH_TERMINALS"))
}

/**
 * <pre>
 *  MUTATION
 *         |---> [SETTERMINALS]{@link module:store/mutations.SETTERMINALS}
 *         |
 *         |---> [API_FAILURE]{@link module:store/mutations.API_FAILURE}
 * </pre>
 */
export const SETTERMINALS = (context, terminals) => {
  let version = context.state.dataVersions.terminals + 1

  return api
    .post("/tavCloud/api/v1/put/terminals", terminals)
    .then(response => context.dispatch("GETTERMINALS"))
}

/**
 * <pre>
 *  MUTATION
 *         |---> [FETCH_OPERATORS]{@link module:store/mutations.FETCH_OPERATORS}
 * </pre>
 */
export const GETOPERATORS = context => {
  context.commit("LOADING")
  return api
    .get("/tavCloud/api/v1/get/operators/")
    .then(response => context.commit("FETCH_OPERATORS", response))
    .catch(error => context.commit("FETCH_OPERATORS"))
}

/**
 * <pre>
 *  MUTATION
 *         |---> [SETOPERATORS]{@link module:store/mutations.SETOPERATORS}
 * </pre>
 */
export const SETOPERATORS = (context, operators) => {
  let version = context.state.dataVersions.operators + 1

  return api
    .post("/tavCloud/api/v1/put/operators", operators)
    .then(response => context.dispatch("GETOPERATORS"))
}

/**
 * <pre>
 *  MUTATION
 *         |---> [GETOPERATORSRIGHTS]{@link module:store/mutations.GETOPERATORSRIGHTS}
 * </pre>
 */

export const GETOPERATORSRIGHTS = context => {
  context.commit("LOADING")
  return api.get("/users/rights").then(response => context.commit("UPDATE_RIGHTS", response))
}

/**
 * <pre>
 *  MUTATION
 *         |---> [FETCH_NEXT_PVI]{@link module:store/mutations.FETCH_NEXT_PVI}
 *         |
 *         |---> [API_FAILURE]{@link module:store/mutations.API_FAILURE}
 * </pre>
 */
export const GETNEXTPVI = (context, payload) => {
  context.commit("LOADING")
  return api
    .get("/prodvaringr/next")
    .then(response => context.commit("FETCH_NEXT_PVI", {data: response.body, callback: payload.callback}))
    .catch(error => context.commit("API_FAILURE", error))
}

/**
 * <pre>
 *  MUTATION
 *         |---> [UPDATE_PVI]{@link module:store/mutations.UPDATE_PVI}
 *         |
 *         |---> [API_FAILURE]{@link module:store/mutations.API_FAILURE}
 * </pre>
 */
export const UPDATEPVI = (context, payload) => {
  context.commit("LOADING")

  let fd = new FormData()

  if (payload.img != null) {
    fd.append("file", payload.img)
    fd.append("data", JSON.stringify(payload.pvi))
  } else {
    fd.append("data", JSON.stringify(payload.pvi))
  }

  return api
    .post("/prodvaringr", fd)
    .then(response => context.commit("UPDATE_PVI", {data: response.body, callback: payload.callback, ref: payload.pvi._id}))
    .catch(error => context.commit("API_FAILURE", error))
}

/**
 * <pre>
 *  MUTATION
 *         |---> [SEARCH_IMAGES]{@link module:store/mutations.SEARCH_IMAGES}
 *         |
 *         |---> [API_FAILURE]{@link module:store/mutations.API_FAILURE}
 * </pre>
 */
export const SEARCHIMAGES = (context, payload) => {
  context.commit("LOADING")
  return api
    .get(`/prodvaringr/ricerca-immagini/${payload.page}/${payload.search}`)
    .then(response => context.commit("SEARCH_IMAGES", {data: response.body, callback: payload.callback}))
    .catch(error => context.commit("API_FAILURE", error))
}

/**
 * <pre>
 *  MUTATION
 *         |---> [FETCH_MENU]{@link module:store/mutations.FETCH_MENU}
 *         |
 *         |---> [API_FAILURE]{@link module:store/mutations.API_FAILURE}
 * </pre>
 */
export const GETMENU = context => {
  context.commit("LOADING")
  return api
    .get("/menu")
    .then(response => context.commit("FETCH_MENU", response))
    .catch(error => context.commit("API_FAILURE", error))
}

/**
 * <pre>
 *  MUTATION
 *         |---> [FETCH_MENU_ROWS]{@link module:store/mutations.FETCH_MENU_ROWS}
 *         |
 *         |---> [API_FAILURE]{@link module:store/mutations.API_FAILURE}
 * </pre>
 */
export const GETMENUROWS = (context, payload) => {
  context.commit("LOADING")
  return api
    .get(`/menu/get-rows/${payload.menu}`)
    .then(response => context.commit("FETCH_MENU_ROWS", {data: response.body, callback: payload.callback}))
    .catch(error => context.commit("API_FAILURE", error))
}

/**
 * <pre>
 *  MUTATION
 *         |---> [UPDATE_MENU]{@link module:store/mutations.UPDATE_MENU}
 *         |
 *         |---> [API_FAILURE]{@link module:store/mutations.API_FAILURE}
 * </pre>
 */
export const UPDATEMENU = (context, payload) => {
  context.commit("LOADING")

  let fd = new FormData()

  fd.append("data", JSON.stringify(payload.menu))

  return api
    .post("/menu", fd)
    .then(response => context.commit("UPDATE_MENU", {data: response.body, callback: payload.callback, ref: payload.menu._id}))
    .catch(error => context.commit("API_FAILURE", error))
}

/**
 * <pre>
 *  MUTATION
 *         |---> [UPDATE_MENU_ROWS]{@link module:store/mutations.UPDATE_MENU_ROWS}
 *         |
 *         |---> [API_FAILURE]{@link module:store/mutations.API_FAILURE}
 * </pre>
 */
export const UPDATEMENUROWS = (context, payload) => {
  context.commit("LOADING")

  let fd = new FormData()

  if (payload.rows && payload.rows.length > 0) {
    payload.rows.forEach(row => {
      if (row.uploadImg != null) {
        fd.append("file", row.uploadImg, row._id)
        row.uploadImgName = row._id
        delete row.uploadImg
      }
    })
  }

  fd.append("data", JSON.stringify(payload.rows.map(row => JSON.stringify(row))))

  return api
    .post("/menu/put-rows", fd)
    .then(response => context.commit("UPDATE_MENU_ROWS", {data: response.body, callback: payload.callback}))
    .catch(error => context.commit("API_FAILURE", error))
}

/**
 * <pre>
 *  MUTATION
 *         |---> [FETCH_TAGS]{@link module:store/mutations.FETCH_TAGS}
 *         |
 *         |---> [API_FAILURE]{@link module:store/mutations.API_FAILURE}
 * </pre>
 */
export const GETTAGS = context => {
  context.commit("LOADING")
  return api
    .get("/tags")
    .then(response => context.commit("FETCH_TAGS", response))
    .catch(error => context.commit("API_FAILURE", error))
}

/**
 * <pre>
 *  MUTATION
 *         |---> [UPDATE_TAG]{@link module:store/mutations.UPDATE_TAG}
 *         |
 *         |---> [API_FAILURE]{@link module:store/mutations.API_FAILURE}
 * </pre>
 */
export const UPDATETAG = (context, payload) => {
  context.commit("LOADING")

  let fd = new FormData()

  if (payload.img != null) {
    fd.append("file", payload.img)
    fd.append("data", JSON.stringify(payload.tag))
  } else {
    fd.append("data", JSON.stringify(payload.tag))
  }

  return api
    .post("/tags", fd)
    .then(response => context.commit("UPDATE_TAG", {data: response.body, callback: payload.callback, ref: payload.tag._id}))
    .catch(error => context.commit("API_FAILURE", error))
}

/**
 * <pre>
 *  MUTATION
 *         |---> [FETCH_NEXT_TAG]{@link module:store/mutations.FETCH_NEXT_TAG}
 *         |
 *         |---> [API_FAILURE]{@link module:store/mutations.API_FAILURE}
 * </pre>
 */
export const GETNEXTTAG = (context, payload) => {
  context.commit("LOADING")
  return api
    .get("/tags/next")
    .then(response => context.commit("FETCH_NEXT_TAG", {data: response.body, callback: payload.callback}))
    .catch(error => context.commit("API_FAILURE", error))
}

/**
 * <pre>
 *  MUTATION
 *         |---> [FETCH_TAVOLI]{@link module:store/mutations.FETCH_TAVOLI}
 *         |
 *         |---> [API_FAILURE]{@link module:store/mutations.API_FAILURE}
 * </pre>
 */
export const GETTAVOLI = context => {
  context.commit("LOADING")
  return api
    .get("/tavoli")
    .then(response => context.commit("FETCH_TAVOLI", response))
    .catch(error => context.commit("API_FAILURE", error))
}

/**
 * <pre>
 *  MUTATION
 *         |---> [UPDATE_TAVOLO]{@link module:store/mutations.UPDATE_TAVOLO}
 *         |
 *         |---> [API_FAILURE]{@link module:store/mutations.API_FAILURE}
 * </pre>
 */
export const UPDATETAVOLO = (context, payload) => {
  context.commit("LOADING")

  let fd = new FormData()

  fd.append("data", JSON.stringify(payload.tavolo))

  return api
    .post("/tavoli", fd)
    .then(response => context.commit("UPDATE_TAVOLO", {data: response.body, callback: payload.callback, ref: payload.tavolo._id}))
    .catch(error => context.commit("API_FAILURE", error))
}

/**
 * <pre>
 *  MUTATION
 *         |---> [FETCH_NEXT_TV]{@link module:store/mutations.FETCH_NEXT_TV}
 *         |
 *         |---> [API_FAILURE]{@link module:store/mutations.API_FAILURE}
 * </pre>
 */
export const GETNEXTTV = (context, payload) => {
  context.commit("LOADING")
  return api
    .get("/tavoli/next")
    .then(response => context.commit("FETCH_NEXT_TV", {data: response.body, callback: payload.callback}))
    .catch(error => context.commit("API_FAILURE", error))
}

/**
 * <pre>
 *  MUTATION
 *         |---> [DOWNLOAD_TAVOLI]{@link module:store/mutations.DOWNLOAD_TAVOLI}
 *         |
 *         |---> [API_FAILURE]{@link module:store/mutations.API_FAILURE}
 * </pre>
 */
export const DOWNLOADTAVOLI = (context, payload) => {
  context.commit("LOADING")
  return api
    .get("/tavoli/download", {responseType: "arraybuffer"})
    .then(response => context.commit("DOWNLOAD_TAVOLI", {data: response, callback: payload.callback}))
    .catch(error => context.commit("API_FAILURE", error))
}

/**
 * <pre>
 *  MUTATION
 *         |---> [FETCH_LISTINI]{@link module:store/mutations.FETCH_LISTINI}
 *         |
 *         |---> [API_FAILURE]{@link module:store/mutations.API_FAILURE}
 * </pre>
 */
export const GETLISTINI = context => {
  context.commit("LOADING")
  return api
    .get("/listini")
    .then(response => context.commit("FETCH_LISTINI", response))
    .catch(error => context.commit("API_FAILURE", error))
}

/**
 * <pre>
 *  MUTATION
 *         |---> [UPDATE_LISTINO]{@link module:store/mutations.UPDATE_LISTINO}
 *         |
 *         |---> [API_FAILURE]{@link module:store/mutations.API_FAILURE}
 * </pre>
 */
export const UPDATELISTINO = (context, payload) => {
  context.commit("LOADING")

  let fd = new FormData()

  fd.append("data", JSON.stringify(payload.listino))

  return api
    .post("/listini", fd)
    .then(response => context.commit("UPDATE_LISTINO", {data: response.body, callback: payload.callback, ref: payload.listino._id}))
    .catch(error => context.commit("API_FAILURE", error))
}

/**
 * <pre>
 *  MUTATION
 *         |---> [TOOLBAR_ACTIONS]{@link module:store/mutations.TOOLBAR_ACTIONS}
 * </pre>
 */
export const TOOLBAR_ACTIONS = (context, actions) => {
  context.commit("TOOLBAR_ACTIONS", actions)
}

/**
 * <pre>
 *  MUTATION
 *         |---> [TOOLBAR_TITLE]{@link module:store/mutations.TOOLBAR_TITLE}
 * </pre>
 */
export const TOOLBAR_TITLE = (context, title) => {
  context.commit("TOOLBAR_TITLE", title)
}

/**
 * <pre>
 *  MUTATION
 *         |---> [SET_LISTINO]{@link module:store/mutations.SET_LISTINO}
 * </pre>
 */
export const SET_LISTINO = (context, listino) => {
  context.commit("SET_LISTINO", listino)
}

/**
 * <pre>
 *  MUTATION
 *         |---> [PUSHLOADING]{@link module:store/mutations.PUSHLOADING}
 * </pre>
 */
export const PUSH_LOADING = context => {
  context.commit("PUSHLOADING")
}

/**
 * <pre>
 *  MUTATION
 *         |---> [POPLOADING]{@link module:store/mutations.POPLOADING}
 * </pre>
 */
export const POP_LOADING = context => {
  context.commit("POPLOADING")
}

/**
 * <pre>
 *  MUTATION
 *         |---> [PUSH_ERROR]{@link module:store/mutations.PUSH_ERROR}
 * </pre>
 */
export const PUSH_ERROR = (context, error) => {
  context.commit("PUSH_ERROR", error)
}

/**
 * <pre>
 *  MUTATION
 *         |---> [PUSH_MESSAGE]{@link module:store/mutations.PUSH_MESSAGE}
 * </pre>
 */
export const PUSH_MESSAGE = (context, msg) => {
  context.commit("PUSH_MESSAGE", msg)
}

/**
 * <pre>
 *  MUTATION
 *         |---> [LOGIN]{@link module:store/mutations.LOGIN}
 *         |
 *         |---> [API_FAILURE]{@link module:store/mutations.API_FAILURE}
 * </pre>
 */
export const LOGIN = (context, creds) => {
  context.commit("LOADING")
  return api
    .post("/users/authenticate", {username: creds.username, password: creds.password})
    .then(response => {
      context.commit("LOGIN", response)
    })
    .catch(error => context.commit("API_FAILURE", error))
}

/**
 * <pre>
 *  MUTATION
 *         |---> [LOGOUT]{@link module:store/mutations.LOGOUT}
 * </pre>
 */
export const LOGOUT = context => {
  context.commit("LOGOUT")
}

/**
 * <pre>
 *  MUTATION
 *         |---> [GET_CURRENT_USER]{@link module:store/mutations.GET_CURRENT_USER}
 *         |
 *         |---> [API_FAILURE]{@link module:store/mutations.API_FAILURE}
 * </pre>
 */
export const GETCURRENTUSER = context => {
  context.commit("LOADING")
  return api
    .get("/users/current")
    .then(response => {
      if (!response.body.settings.hasOwnProperty("businessPhones")) {
        response.body.settings.businessPhones = {firstPhone: "", secondPhone: ""}
      }
      context.commit("GET_CURRENT_USER", response)
    })
    .catch(error => context.commit("API_FAILURE", error))
}

/**
 * <pre>
 *  MUTATION
 *         |---> [UPDATESETTINGS]{@link module:store/mutations.UPDATESETTINGS}
 *         |
 *         |---> [API_FAILURE]{@link module:store/mutations.API_FAILURE}
 * </pre>
 */
export const UPDATESETTINGS = (context, user) => {
  context.commit("LOADING")
  return api
    .put(`/users/change-settings/${user.id}`, user.settings)
    .then(response => context.commit("UPDATESETTINGS", user.settings))
    .catch(error => context.commit("API_FAILURE", error))
}

/**
 * <pre>
 *  MUTATION
 *         |---> [FETCH_ORDINI]{@link module:store/mutations.FETCH_ORDINI}
 *         |
 *         |---> [API_FAILURE]{@link module:store/mutations.API_FAILURE}
 * </pre>
 */
export const GETORDINI = (context, payload) => {
  context.commit("LOADING")
  return api
    .post(`/ordini/filtered`, JSON.stringify(payload.pagination))
    .then(response => context.commit("FETCH_ORDINI", {data: response.body, callback: payload.callback}))
    .catch(error => context.commit("API_FAILURE", error))
}

/**
 * <pre>
 *  MUTATION
 *         |---> [CHECK_ORDINE]{@link module:store/mutations.CHECK_ORDINE}
 *         |
 *         |---> [API_FAILURE]{@link module:store/mutations.API_FAILURE}
 * </pre>
 */
export const CHECKORDINE = (context, payload) => {
  return api
    .get(`/ordini/check/${payload.ordine}`)
    .then(response => context.commit("CHECK_ORDINE", {data: response.body, callback: payload.callback}))
    .catch(error => context.commit("API_FAILURE", error))
}

/**
 * <pre>
 *  MUTATION
 *         |---> [RISTAMPA]{@link module:store/mutations.RISTAMPA}
 *         |
 *         |---> [API_FAILURE]{@link module:store/mutations.API_FAILURE}
 * </pre>
 */
export const RISTAMPA = (context, payload) => {
  context.commit("LOADING")
  return api
    .get(`/ordini/ristampa/${payload.ordine}`)
    .then(response => context.commit("RISTAMPA", {data: response.body, callback: payload.callback}))
    .catch(error => context.commit("API_FAILURE", error))
}

/**
 * <pre>
 *  MUTATION
 *         |---> [GETALLERGENI]{@link module:store/mutations.GETALLERGENI}
 *         |
 *         |---> [API_FAILURE]{@link module:store/mutations.API_FAILURE}
 * </pre>
 */
export const GETALLERGENI = (context, payload) => {
  context.commit("LOADING")
  return api
    .get(`/prodvaringr/allergeni`)
    .then(response => context.commit("GETALLERGENI", response))
    .catch(error => context.commit("API_FAILURE", error))
}

/**
 * <pre>
 *  MUTATION
 *         |---> [LOCK]{@link module:store/mutations.LOCK}
 * </pre>
 */
export const LOCK = context => {
  context.commit("LOCK")
}

/**
 * <pre>
 *  MUTATION
 *         |---> [CHANGED]{@link module:store/mutations.CHANGED}
 * </pre>
 */
export const CHANGED = context => {
  context.commit("CHANGED")
}

/**
 * <pre>
 *  MUTATION
 *         |---> [CHANGED]{@link module:store/mutations.LIBSELECTEDTAB}
 * </pre>
 */
export const LIBSELECTEDTAB = (context, payload) => {
  context.commit("LIB_SELECTED_TAB", payload)
}

/**
 * <pre>
 *  MUTATION
 *         |---> [CHANGED]{@link module:store/mutations.HANDLE_LIB_FILTER}
 * </pre>
 */
export const HANDLELIBFILTER = (context, {tag, target}) => {
  context.commit("HANDLE_LIB_FILTER", {tag, target})
}

export const RESETLIBFILTER = (context, {target}) => {
  context.commit("RESET_LIB_FILTER", {target})
}

//PAYMENT APIS

/**
 * <pre>
 *  MUTATION
 *         |---> [FETCH_PAYMENTS]{@link module:store/mutations.FETCH_PAYMENTS}
 *         |
 *         |---> [API_FAILURE]{@link module:store/mutations.API_FAILURE}
 * </pre>
 */
export const GETPAYMENTS = context => {
  context.commit("LOADING")
  return api
    .get("/tavCloud/api/v1/get/payments/")
    .then(response => context.commit("FETCH_PAYMENTS", response))     
    .catch(error => context.commit("FETCH_PAYMENTS"))
}

/**
 * <pre>
 *  MUTATION
 *         |---> [SETPAYMENTS]{@link module:store/mutations.SETPAYMENTS}
 *         |
 *         |---> [API_FAILURE]{@link module:store/mutations.API_FAILURE}
 * </pre>
 */
export const SETPAYMENTS = (context, payments) => {
  let version = context.state.dataVersions.paymentTypes + 1

  return api
    .post("/tavCloud/api/v1/put/payments", payments) 
    .then(response => context.dispatch("GETPAYMENTS"))
}

//DISCOUNT APIS

/**
 * <pre>
 *  MUTATION
 *         |---> [FETCH_DISCOUNTS]{@link module:store/mutations.FETCH_DISCOUNTS}
 *         |
 *         |---> [API_FAILURE]{@link module:store/mutations.API_FAILURE}
 * </pre>
 */
export const GETDISCOUNTS = context => {
  context.commit("LOADING")
  return api
    .get("/tavCloud/api/v1/get/discounts/")
    .then(response => context.commit("FETCH_DISCOUNTS", response))
    .catch(error => context.commit("FETCH_DISCOUNTS"))
}

/**
 * <pre>
 *  MUTATION
 *         |---> [SETDISCOUNTS]{@link module:store/mutations.SETDISCOUNTS}
 *         |
 *         |---> [API_FAILURE]{@link module:store/mutations.API_FAILURE}
 * </pre>
 */
export const SETDISCOUNTS = (context, discounts) => {
  let version = context.state.dataVersions.discountTypes + 1

  return api
    .post("/tavCloud/api/v1/put/discounts", discounts)
    .then(response => context.dispatch("GETDISCOUNTS"))
}

export const FETCH_ITALIAN_CITIES = context => {
  context.commit("LOADING")
  return api
    .get("/cities/it")
    .then(response => context.commit("FETCH_ITALIAN_CITIES", response))
    .catch(error => context.commit("FETCH_ITALIAN_CITIES", error))
}

export const CLONE_MENU = (context, payload) => {
  context.commit("LOADING")
  return api
    .post("/menu/clone", {
      menuId: payload.menu._id,
    })
    .then(response => context.commit("FETCH_MENU", response))
    .catch(error => context.commit("API_FAILURE", error))
}



// WEBPACK FOOTER //
// ./src/store/actions.js